<!-- eslint-disable vue/require-explicit-emits -->
<template>
  <iColumn
    :class="{
      ...classList,
      'empty-layout': isEmpty && !hasABorder,
      'root-layout': isRootLayout,
      'layout': true,
    }"
    v-bind="{
      ...myLayoutProps,
      'data-identifier': identifier,
      'data-parent-id': identifier,
      'draggable': editMode && isDraggable(identifier, configuration) && !breakpoint
    }"
    v-on="myEventListeners"
  >
    <Teleport to="body">
      <DynamicComponentContextualMenu
        v-if="(isDynamicAppComponent ? true : canEditPublication)
          && showContextualMenu
          && contextMenuFixedPositionStyle.top
          && contextMenuFixedPositionStyle.left"
        v-bind="contextMenuAttrs"
        v-on="contextMenuEvents"
      />
    </Teleport>
    <div
      v-if="canResizeHorizontally && (mouseOver || selectedHoverBorder)"
      class="resize-handle left"
      @mousedown.stop="handleMouseDownResize($event, 'left')"
    />
    <div
      v-if="canResizeHorizontally && (mouseOver || selectedHoverBorder)"
      class="resize-handle right"
      @mousedown.stop="handleMouseDownResize($event, 'right')"
    />
    <div
      v-if="canResizeVertically && (mouseOver || selectedHoverBorder)"
      class="resize-handle top"
      @mousedown.stop="handleMouseDownResize($event, 'top')"
    />
    <div
      v-if="canResizeVertically && (mouseOver || selectedHoverBorder)"
      class="resize-handle bottom"
      @mousedown.stop="handleMouseDownResize($event, 'bottom')"
    />
    <slot />
  </iColumn>
</template>

<script>
import {
  LayoutElementMixin,
} from "%/dynamic-components/render-engine/components/elements/layouts/layout-element-mixin";
import SpacingOptions from "%/dynamic-components/render-engine/bundles/spacing-options";
import BackgroundOptions from "%/dynamic-components/render-engine/bundles/background-options";
import LayoutWrap from "%/dynamic-components/render-engine/options/layout-options/layout-wrap";
import VerticalLayoutAlign from "%/dynamic-components/render-engine/options/layout-options/vertical-layout-align";
import VerticalLayoutVerticalAlign
  from "%/dynamic-components/render-engine/options/layout-options/vertical-layout-vertical-align";
import VerticalLayoutPositionOptions from "%/dynamic-components/render-engine/bundles/vertical-layout-position-options";
import RootLayoutPositionOptions from "%/dynamic-components/render-engine/bundles/root-layout-position-options";
import DynamicComponentContextualMenu
  from "%/dynamic-components/render-engine/components/DynamicComponentContextualMenu.vue";
import AppearanceOptions from "%/dynamic-components/render-engine/bundles/appearance-options";
import PositioningOptions from "%/dynamic-components/render-engine/bundles/positioning-options";
import BackgroundColor from "%/dynamic-components/render-engine/options/background-options/background-color";
import BackgroundPosition from "%/dynamic-components/render-engine/options/background-options/background-position";
import BackgroundSize from "%/dynamic-components/render-engine/options/background-options/background-size";
import BackgroundRepeat from "%/dynamic-components/render-engine/options/background-options/background-repeat";
import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import AnimationOptions from "%/dynamic-components/render-engine/bundles/animations-options";
import EffectsOptions from "%/dynamic-components/render-engine/bundles/effects-options";
import AnimationEffectsOptions from "%/dynamic-components/render-engine/bundles/animation-effects-options";

export default {
  name: "VerticalContainer",
  components: { DynamicComponentContextualMenu },
  mixins: [LayoutElementMixin],
  deprecated: true,
  elementPanelSettings: {
    displayName: "Vertical Container",
  },
  data() {
    return {
      VerticalLayoutAlign,
      VerticalLayoutVerticalAlign,
      LayoutWrap,
      BaseOption,
      BackgroundRepeat,
      BackgroundPosition,
      BackgroundColor,
      BackgroundSize,
    };
  },
  mounted() {
    if (this.editMode) {
      this.configureOptionsAndBuilder();
    }
  },
  optionBundles: [
    PositioningOptions,
    new VerticalLayoutPositionOptions({
      "default.layout-width": "hug",
      "default.layout-height": "fill",
    }),
    new AppearanceOptions({}, {
      "border-radius": false,
    }),
    AnimationOptions,
    AnimationEffectsOptions,
    new EffectsOptions({}, {
      "text-shadow": true,
    }),
    SpacingOptions,
    BackgroundOptions,
  ],
  methods: {
    configureOptionsAndBuilder() {
      if (this.isRootLayout) {
        this.setEditorElementConfig(this.configuration.identifier, "isDeletable", false);
        this.setEditorElementConfig(this.configuration.identifier, "isDraggable", false);
        this.setEditorElementConfig(this.configuration.identifier, "isDuplicatable", false);
        this.setEditorElementConfig(this.configuration.identifier, "canWrap", false);
        this.setEditorElementConfig(this.configuration.identifier, "canCreateCustomComponent", false);

        if (this.isPage) {
          this.setEditorElementOptionsConfig(this.configuration.identifier, {
            bundles: [
              new PositioningOptions({
                "default.positioning": {
                  position: "relative",
                  top: "unset",
                  right: "unset",
                  bottom: "unset",
                  left: "unset",
                },
              }),
              RootLayoutPositionOptions,
              new AppearanceOptions({}, {
                "visible": {
                  disable: true,
                  message: "Visibility can not be toggled for root containers",
                },
                "border-radius": false,
              }),
              SpacingOptions,
              BackgroundOptions,
            ],
          });
        }
      }
    },
  },
};
</script>
